module.exports = __webpack_public_path__ + "img/custom-app.4faf59cd.png";